// test818
(818 && 0);
